export default __webpack_public_path__ + "static/media/1949.5c7ff29d.png";